/**
 * Utilities for tracking the last authentication method used.
 * Helps display "Last used" badge on sign-in/sign-up pages.
 */

const LAST_AUTH_METHOD_KEY = 'orsay_last_auth_method';

export type AuthMethod = 'google' | 'email';

/**
 * Store the last authentication method used.
 * Called after successful sign-in or sign-up.
 */
export function setLastAuthMethod(method: AuthMethod): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(LAST_AUTH_METHOD_KEY, method);
  } catch (error) {
    // Silent fail - not critical if localStorage is unavailable
    // eslint-disable-next-line no-console
    console.warn('Failed to store last auth method:', error);
  }
}

/**
 * Get the last authentication method used.
 * Returns null if no method was previously stored.
 */
export function getLastAuthMethod(): AuthMethod | null {
  if (typeof window === 'undefined') return null;
  try {
    const method = localStorage.getItem(LAST_AUTH_METHOD_KEY);
    return method === 'google' || method === 'email' ? method : null;
  } catch {
    return null;
  }
}

/**
 * Clear the stored authentication method.
 * Useful on logout.
 */
export function clearLastAuthMethod(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(LAST_AUTH_METHOD_KEY);
  } catch {
    // Silent fail
  }
}
